import type { GameId } from "@hunch/core";
import { GAME_BRANDING } from "@hunch/branding";

export interface GameModule {
  id: GameId;
  /** Route the hub tile links to. Each game owns its own sub-routes below this. */
  route: string;
  name: string;
  tagline: { de: string; en: string };
  roundsInfo: { de: string; en: string };
}

/**
 * Static registry of game modules, per spec §5: a new game is a new module
 * plus a registry entry, no hub rework required. Active/sort order still
 * comes from the server (`/api/public/game-tiles`) — this registry only
 * supplies what's intrinsic to the module (route, static branding).
 */
export const GAME_REGISTRY: Record<GameId, GameModule> = {
  timeslip: {
    id: "timeslip",
    route: "/spiele/timeslip",
    name: GAME_BRANDING.timeslip.name,
    tagline: GAME_BRANDING.timeslip.tagline,
    roundsInfo: GAME_BRANDING.timeslip.roundsInfo,
  },
  crowflight: {
    id: "crowflight",
    route: "/spiele/crowflight",
    name: GAME_BRANDING.crowflight.name,
    tagline: GAME_BRANDING.crowflight.tagline,
    roundsInfo: GAME_BRANDING.crowflight.roundsInfo,
  },
  huesswork: {
    id: "huesswork",
    route: "/spiele/huesswork",
    name: GAME_BRANDING.huesswork.name,
    tagline: GAME_BRANDING.huesswork.tagline,
    roundsInfo: GAME_BRANDING.huesswork.roundsInfo,
  },
};
